import { SkeletonText } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useQuery } from 'react-query'

import { fetchContactById } from '@modules-deprecated/app/contacts/query-api'

import { QueryKeys } from '../../enums/queryKeys'

interface ContactNameAsyncProps {
  contactId: string
}

export const ContactNameAsync = ({ contactId }: ContactNameAsyncProps): ReactElement => {
  const { data, isLoading } = useQuery([QueryKeys.Contacts, contactId], () => fetchContactById(contactId))

  return isLoading ? <SkeletonText variant="h4" /> : <span>{data?.contact.name}</span>
}
